import preparedReducer from './reducer';
import { settingsInitial } from './states';
import {
  requestChatSettings,
  updateChatSettings,
} from './actions';

export const reducer = preparedReducer;

export const SLICE_NAME = 'chatSettings';

export const selectChatSettings = (state) => state[SLICE_NAME]?.data || settingsInitial;

export const selectChatSettingsLoading = (state) => !!state[SLICE_NAME]?.loading;

export const selectChatSettingsLoaded = (state) => !!state[SLICE_NAME]?.loaded;

export const selectChatSettingsSaving = (state) => !!state[SLICE_NAME]?.saving;

export const actions = {
  requestChatSettings,
  updateChatSettings,
};
